// src/components/Header.jsx
import { useNavigate } from 'react-router-dom';
import { logout } from '../common/auth';
import { goToMyPage } from '../common/navigation';

const Header = ({ title, companyName }) => {
  const navigate = useNavigate();

  return (
    <header>
      <style>
        {`
        .myhead {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        }

        .w-65 {width: 65%;}

        @media (max-width: 560px) {
          .sm-column {flex-direction: column;}
          .head-logo {width: 70% !important;}
          .sm-left {text-align: left !important;}
          .sm-w-70 {width: 70%;}
          .left-one {width : 70%;}
        }
      `}
      </style>
      <div className="flex-nowrap item-center border-bottom-blue p-t-20 myhead">
        <div className='sm-column flex-nowrap item-center w-65'>
          <div style={{ padding: '15px 5%' }} className='left-one'>
            <img src="/logo.png" alt="top-logo" style={{ width: '50%' }} className='head-logo' />
            <p style={{ fontWeight: 'bold', fontSize: '16px' }} className='head-title'>
              {title}
            </p>
          </div>

          <div
            style={{ textAlign: 'center', cursor: 'pointer' }}
            onClick={() => goToMyPage(navigate)}
            className='sm-left sm-w-70'
          >
            <img src="/messe-icon.png" alt="top-icon" style={{ width: '50%' }} className='head-logo' />
          </div>
        </div>

        <div
          style={{
            width: '35%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: '20px',
            gap: '15px',
          }}
          className='sm-column'
        >
          {companyName && (
            <p style={{ margin: 0 }}>{companyName}</p>
          )}

          <button
            onClick={() => logout(navigate)}
            className="logout-button"
          >
            <i className="bi bi-door-closed" /> ログアウト
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;